import Axios from 'axios';
import uploadApi from '@/apis/upload.api';

/**
 * @description Upload a file to S3
 * @param {File} file File to be uploaded
 * @param {'image' | 'document'} type File type
 * @returns {Promise<string>} Uploaded file URL from S3
 */
export default async function uploadFile(file, type) {
  if (!file) throw new Error('Missing file');

  // Get s3 signed url from backend
  const { data } = await uploadApi.getSignedUrl(type, file.type);

  // Get the full url, cutting query params out
  const [url] = data.url.split('?');

  // Create a new file to match the one provided from API
  const payload = new File([file], data.fileName, { type: file.type });

  // Upload file to s3
  await Axios.put(data.url, payload, { headers: { 'Content-Type': file.type } });

  return url;
}
